module.exports = __webpack_public_path__ + "static/img/icon_js_aftersales.0bd44a13.png";